// Preset form values ([data-form-presets] = JSON { field alias: value } around a form, _includes/contact.twig): each
// value goes into the form's field fields[<alias>] (hidden fields such as the solution on its detail page).
export function initFormPresets() {
	document.querySelectorAll('[data-form-presets]').forEach((box) => {
		let presets
		try {
			presets = JSON.parse(box.dataset.formPresets)
		} catch {
			return
		}
		Object.entries(presets).forEach(([alias, value]) => {
			box.querySelectorAll(`[name="fields[${alias}]"]`).forEach((field) => {
				field.value = value
			})
		})
	})
}
